import {
  Autocomplete,
  Box,
  Collapse,
  FormControl,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";

import axios from "axios";
import FinanceImg from "../assets/images/services/support-center/financial.png";
import RoomCleaningImg from "../assets/images/services/support-center/cleaning.png";
import AccommodationImg from "../assets/images/services/support-center/accommodation.png";
import ExtensionImg from "../assets/images/services/support-center/extension.png";
import MaintananceImg from "../assets/images/services/support-center/maintanance.png";
import OtherImg from "../assets/images/services/support-center/other.png";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import NewRequest from "../components/Requests/NewRequest";
import StyledTitleDot from "../components/common/StyledTitleDot";
import BreadCrumbs from "../components/Breadcrumbs";
import axiosInstance from "../axiosInstance";
import { useTranslation } from "react-i18next";
export const categoryOptionsFirst = [
  {
    id: "maintenance",
    name: "Maintenance Request",
    trsText: "maintenanceRequests",
    img: MaintananceImg,
  },
  {
    id: "financial",
    name: "Financial Requests",
    trsText: "financialRequests",
    img: FinanceImg,
  },
  {
    id: "room-cleaning-request",
    name: "Room Cleaning Request",
    trsText: "roomCleaningRequests",
    img: RoomCleaningImg,
  },
  {
    id: "accommodation",
    name: "Accommodation Request",
    trsText: "accommodationRequests",
    img: AccommodationImg,
  },
  {
    id: "extension-request",
    name: "Extension Request",
    trsText: "extensionRequests",
    img: ExtensionImg,
  },
  {
    id: "other-request",
    name: "Other Request",
    trsText: "otherRequests",
    img: OtherImg,
  },
];

const CreateTicket = () => {
  // const user = useUser();
  // const {
  //   student_id,
  //   student_firstname,
  //   student_lastname,
  //   student_phone,
  //   student_email,
  // } = user || {};

  const [newMessage, setNewMessage] = useState();
  const [activeRequest] = useState();
  const [, setHeight] = useState(500);
  const [statusControl, setStatusControl] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [tickets, setTickets] = useState(null);
  const [, setLoading] = useState(true);
  const theme = useTheme();
  // useEffect(() => {
  //   if (data) {
  //     data?.forEach((item, idx) => {
  //       if (item?.ticket_status ==="open") {
  //         setStatusControl(true);
  //       }
  //     });
  //   }
  // }, [data]);

  const profile = useSelector((state) => state.profile.profile);
  const { agent_id: partner_id } = profile;
  const { t } = useTranslation();

  useEffect(() => {
    setCategoryOptions(categoryOptionsFirst)
  }, [t])
  const fetchAllTickets = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://webservice.londonist.co.uk/v1/DMCGetTicket",
        {
          api_key: "O0AUQ0KLAD3I71K8YKR82Y6AP",
          partner_id,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setTickets(response?.data?.result);
      // setTickets(RequestData?.result);
    } catch (err) {
      // setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (student_id) {
  //     fetchAllTickets();
  //   }
  // }, [student_id]);

  useEffect(() => {
    fetchAllTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const el = document.getElementById("requestSection");
    if (!el) {
      return;
    }
    const offsetTop = el.offsetTop;
    const height = window.innerHeight - offsetTop - 80;

    setHeight(height > 0 ? height : 500);
  }, []);

  const [otherRequestControl, setOtherRequestControl] = useState(null);
  function handleNewRequest(id) {
    console.log(id, "id here");

    setOtherRequestControl(id);
    // setNewMessage({
    //   mutate,
    // });
    setNewMessage({});
  }

  // useEffect(() => {
  //   if (activeRequest) {
  //     hideMobileNavigation();
  //     return;
  //   }
  //   showMobileNavigation();
  // }, [activeRequest]);

  // useEffect(() => {
  //   return () => {
  //     showMobileNavigation();
  //   };
  // }, []);

  const [selectedStudent, setSelectedStudent] = useState();
  const [warningMessage, setWarningMessage] = useState(null);
  const [students, setStudents] = useState();
  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );

  const getStudents = async () => {
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}auth/students`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
            XRefreshToken: `${token}`, // Bearer token burada ekleniyor
            Accounts: selectedBranchesString,
            "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
          },
        }
      );
      setStudents(response?.data?.student);
    } catch (error) {
      console.error("Hata oluştu!", error);
      return [];
    }
  };

  useEffect(() => {
    getStudents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeStudent = (_event, newValue) => {
    setSelectedStudent(newValue);
  };

  useEffect(() => {
    console.log(selectedStudent, "selected student here");
  }, [selectedStudent]);

  const handleWarningMessage = (type) => {
    setWarningMessage(type);
    setTimeout(() => {
      setWarningMessage(null);
    }, 5000);
  };

  useEffect(() => {
    if (tickets) {
      tickets?.forEach((item, idx) => {
        if (item?.ticket_status !== 1) {
          console.log(item, "İTEM");
          console.log(selectedStudent, "selected student");
          if (selectedStudent?.student_id === item?.student_id) {
            setStatusControl((prev) => [...prev, item?.category]);
          }
        }
      });
    }
  }, [tickets, selectedStudent]);

  return (
    <>
      <Typography className="title" variant="h4">
        {t("createTicket")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("requests"), t("createTicket")]} />

      <FormControl
        sx={{
          minWidth: 240,
        }}
      >
        <Autocomplete
          sx={{
            fieldset: {
              borderColor:
                warningMessage &&
                warningMessage === "selected-student" &&
                "red",
            },
          }}
          fullWidth
          value={selectedStudent}
          onChange={handleChangeStudent}
          disablePortal
          id="combo-box-demo"
          options={students || []}
          disabled={!students?.length}
          getOptionLabel={(option) => option.student_name} // 'name' özelliğini label olarak kullan
          renderInput={(params) => (
            <TextField
              sx={{
                textTransform: 'capitalize'
              }}
              {...params}
              label={t("student")}
              placeholder={t("selectStudent")}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonIcon />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
        {warningMessage && warningMessage === "selected-student" ? (
          <Box
          // sx={{ position: "absolute", bottom: 0, left: 0 }}
          >
            <Typography textTransform={"capitalize"} margin={0} variant="caption" color={"error"}>
              {t("pleaseSelectStudent")}
            </Typography>
          </Box>
        ) : null}
      </FormControl>

      <Box
        // width={{
        //   xs: "100%",
        //   md: "90%",
        //   lg: "80%",
        //   xl: "70%",
        // }}
        alignSelf="center"
      >
        <Grid
          container
          spacing={activeRequest ? 0 : 2}
          mt={4}
          id="requestSection"
        >
          <Grid item xs={12}>
            <Collapse in={!activeRequest}>
              {/* <ButtonBase
                onClick={handleNewRequest}
                // disabled={statusControl}
                sx={{
                  borderRadius: CARD_BORDER_RADIUS + "px",
                  border: statusControl
                    ? "1px solid #999999"
                    : "1px solid #DEDEDE",
                  backgroundColor: statusControl ? "#cccccc" : "FCFCFC",
                  color: "#666666",
                  px: 4,
                  py: 1,
                }}
              >
                <Typography variant="h6" className="fa-solid fa-plus" mr={1} />
                Create Customer Support Request
              </ButtonBase> */}
            </Collapse>
          </Grid>
          {categoryOptions?.map((item, idx) => {
            console.log(item, "item here", statusControl);
            return (
              <Grid key={idx} item xs={12} md={4}>
                <Box
                  onClick={() => {
                    if (!selectedStudent) {
                      handleWarningMessage("selected-student");
                      return false;
                    }
                    if (
                      statusControl?.length &&
                      statusControl?.includes(item?.name)
                    ) {
                      console.log(item, "item here 2");
                      Swal.fire({
                        icon: "warning",
                        title: t("createTicketWarning"),
                        showConfirmButton: false,
                        showCloseButton: true,
                      });
                      return false;
                    } else {
                      if (item?.id === "other-request") {
                        handleNewRequest(null);
                      } else {
                        handleNewRequest(item?.name);
                      }
                    }
                    // if (item?.id === "other-request") {
                    //   handleNewRequest(null);
                    // } else {
                    //   handleNewRequest(item?.name);
                    // }
                    console.log("aa");
                  }}
                  sx={{
                    cursor: "pointer",
                    ".category-img": {
                      transform: "scale(1)",
                      transition: "box-shadow .4s, transform .4s",
                    },
                    "&:hover": {
                      ".category-img": {
                        transform: "scale(1.1)",
                        transition: "box-shadow .4s, transform .4s",
                      },
                      // boxShadow: `0 0 5px ${
                      //   lightMode(theme) ? `#f08049` : `#fff`
                      // }`,
                    },
                    padding: "1rem",
                    borderRadius: "1rem",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: `0 0 3px ${theme.palette.grey[400]}`,
                    // border: `1px solid ${theme.palette.primary.main}`,
                  }}
                >
                  <img
                    className="category-img"
                    src={item?.img}
                    alt={item?.name || ""}
                    height={"75px"}
                    width={"auto"}
                    style={{
                      margin: "2rem 0",
                      maxHeight: "75px",
                      objectFit: "contain",
                      objectPosition: "center",
                    }}
                  />
                  <Box
                    textAlign={"center"}
                    textTransform={"capitalize"}
                    mt={3}
                    pt={2}
                    sx={{
                      width: "100%",
                      borderTop: `1px solid ${theme.palette.grey[200]}`,
                    }}
                  >
                    {t(item?.trsText)}
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <NewRequest
        newRequest={newMessage}
        onClose={setNewMessage}
        fetchAllTickets={fetchAllTickets}
        tickets={tickets}
        otherRequestControl={otherRequestControl}
        selectedStudent={selectedStudent}
        partnerId={partner_id}
      />
    </>
  );
};

export default CreateTicket;
